import { Directive, ElementRef, HostListener, Input, inject } from '@angular/core';

/**
 * Sets a native `title` on the host **only when its text is actually clipped** by an ellipsis.
 *
 * "How do we know it needs truncating?" — an element whose content is wider than its box reports
 * `scrollWidth > clientWidth`. We check that on hover (the title only matters for a mouse tooltip;
 * screen readers already read the full text content), so we never show a redundant tooltip on
 * options that fit. Apply to the element that carries `text-overflow: ellipsis`.
 */
@Directive({
  selector: '[adminuiTruncationTitle]',
  standalone: true
})
export class AdminuiTruncationTitleDirective {
  /** The full text to surface as the tooltip when the element is truncated. */
  @Input('adminuiTruncationTitle') text = '';

  private readonly host = inject(ElementRef<HTMLElement>);

  @HostListener('mouseenter')
  updateTitle(): void {
    const el = this.host.nativeElement;
    el.title = el.scrollWidth > el.clientWidth ? this.text : '';
  }
}
